import authorizedAPIInstance from '@/api/authorizedAPI';
export const getSecondFeatureData = async (
  params?: any
): Promise<any> => {
  const { data } = await authorizedAPIInstance.get<any>(
    '/second-feature',
    {
      params,
    }
  );
  return data;
};